import React from "react";

const AddButton = ({ title, onClick }) => (
    <button onClick={onClick} title={title} className="mdl-button mdl-button--fab fab-mini">
        <i className="material-icons text-primary">add</i>
    </button>
);

export default AddButton;
